import React from 'react';
import { useTranslation } from 'react-i18next';
import Flex from '@wix/da-ds/pkg/Flex';
import CommissionPointsAndPrice from '../../../../../CommissionPointsAndPrice';
import s from './FolderPanel.scss';
const FolderPanel = ({ folder , price , dollarsCost  })=>{
    var _folder_premiumFolderData;
    const { t  } = useTranslation();
    const subscribers = (_folder_premiumFolderData = folder.premiumFolderData) === null || _folder_premiumFolderData === void 0 ? void 0 : _folder_premiumFolderData.numSubscribers;
    return /*#__PURE__*/ React.createElement(Flex, {
        className: s['root'],
        alignItems: "flex-start"
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['left']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['title'],
        title: folder.name
    }, folder.name), /*#__PURE__*/ React.createElement("div", {
        className: s['stats']
    }, t('folderCard.stats.artworks', {
        count: folder.size
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['stats-separator']
    }, "|"), t('folderCard.stats.subscribers', {
        count: subscribers
    }))), /*#__PURE__*/ React.createElement("div", {
        className: s['price-wrapper']
    }, /*#__PURE__*/ React.createElement(CommissionPointsAndPrice, {
        points: price,
        price: dollarsCost,
        dollarsClassName: s['price-dollars'],
        pointsClassName: s['price-points']
    })));
};
FolderPanel.displayName = 'FolderPanel';
export default FolderPanel;
